module.exports = __webpack_public_path__ + "static/media/mobile_home_header.0d1a012c.png";